export enum ServiceModelsGetters {
    GET_VIEW = 'GET_VIEW',
}
